<template>
<div ref="PlatShowSetting" id="PlatShowSetting">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">平台信息设置</span>
        <div class="TTL-btn-option">
        <wcbutton :option="{title:'取消锚点定位',type:'del'}" @finish="cannelSelect" />
        </div>
        <div class="TTL-btn-option" v-if="rollbackname!=''">
        <wcbutton :option="{title:'返回历史板块',type:'del'}" @finish="GoBack" />
        </div>
    </div>
    <div>

        <!-- 小程序登录审核显示 -->
        <div class="TTL-form-submit-box">
            <div class="TTL-form-submit-title"><i></i><span>小程序审核设置</span><h>（开关打开并设置有具体值才生效）</h></div>
            <div :class="param.xcx_push_login.isselect ? 'TTL-form-submit-content content-select' : 'TTL-form-submit-content' " ref="xcx_push_login">
                <span class="TTL-form-content-sub width150">显示审核登录入口</span>
                <div class="TTL-switch TTL-open"><el-switch v-model="param.xcx_push_login.is_open" @change="ChangeSetting('xcx_push_login',param.xcx_push_login.is_open)" /></div>
                <div class="TTL-value">
                    <wcinput
                        :value="param.xcx_push_login.value"
                        :option="{placeholder:'店铺id',type:'input',clearable:true,ischange:true,isinput:true,width:'120px'}"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') param.xcx_push_login.value=val.value;
                            if(val.type=='change') ChangeValue('xcx_push_login',param.xcx_push_login.value);
                        }"
                    />
                </div>
                <div class="TTL-value-note">（备注：{{param.xcx_push_login.note}}）</div>
            </div>
        </div>

        <!-- 小程序模块设置 -->
        <div class="TTL-form-submit-box">
            <div class="TTL-form-submit-title"><i></i><span>非付费功能添加数据限制</span><h>（开关打开并设置有具体值才生效）</h></div>
            <div :class="param.member_free_limit_ad.isselect ? 'TTL-form-submit-content content-select' : 'TTL-form-submit-content' " ref="member_free_limit_ad">
                <span class="TTL-form-content-sub width150">添加会员数据限制</span>
                <div class="TTL-switch TTL-open"><el-switch v-model="param.member_free_limit_ad.is_open" @change="ChangeSetting('member_free_limit_ad',param.member_free_limit_ad.is_open)" /></div>
                <div class="TTL-value">
                    <wcinput
                        :value="param.member_free_limit_ad.value"
                        :option="{placeholder:'请填写具体值',type:'input',clearable:true,ischange:true,isinput:true,width:'120px'}"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') param.member_free_limit_ad.value=val.value;
                            if(val.type=='change') ChangeValue('member_free_limit_ad',param.member_free_limit_ad.value);
                        }"
                    />
                </div>
                <div class="TTL-value-note">（备注：{{param.member_free_limit_ad.note}}）</div>
            </div>
            <div :class="param.pet_free_limit_ad.isselect ? 'TTL-form-submit-content content-select' : 'TTL-form-submit-content' " ref="pet_free_limit_ad">
                <span class="TTL-form-content-sub width150">添加宠物数据限制</span>
                <div class="TTL-switch TTL-open"><el-switch v-model="param.pet_free_limit_ad.is_open" @change="ChangeSetting('pet_free_limit_ad',param.pet_free_limit_ad.is_open)" /></div>
                <div class="TTL-value">
                    <wcinput
                        :value="param.pet_free_limit_ad.value"
                        :option="{placeholder:'请填写具体值',type:'input',clearable:true,ischange:true,isinput:true,width:'120px'}"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') param.pet_free_limit_ad.value=val.value;
                            if(val.type=='change') ChangeValue('pet_free_limit_ad',param.pet_free_limit_ad.value);
                        }"
                    />
                </div>
                <div class="TTL-value-note">（备注：{{param.pet_free_limit_ad.note}}）</div>
            </div>
            <div :class="param.record_free_limit_ad.isselect ? 'TTL-form-submit-content content-select' : 'TTL-form-submit-content' " ref="record_free_limit_ad">
                <span class="TTL-form-content-sub width150">添加宠物记录数据限制</span>
                <div class="TTL-switch TTL-open"><el-switch v-model="param.record_free_limit_ad.is_open" @change="ChangeSetting('record_free_limit_ad',param.record_free_limit_ad.is_open)" /></div>
                <div class="TTL-value">
                    <wcinput
                        :value="param.record_free_limit_ad.value"
                        :option="{placeholder:'请填写具体值',type:'input',clearable:true,ischange:true,isinput:true,width:'120px'}"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') param.record_free_limit_ad.value=val.value;
                            if(val.type=='change') ChangeValue('record_free_limit_ad',param.record_free_limit_ad.value);
                        }"
                    />
                </div>
                <div class="TTL-value-note">（备注：{{param.record_free_limit_ad.note}}）</div>
            </div>
            <div :class="param.remind_free_limit_ad.isselect ? 'TTL-form-submit-content content-select' : 'TTL-form-submit-content' " ref="remind_free_limit_ad">
                <span class="TTL-form-content-sub width150">添加日程提醒数据限制</span>
                <div class="TTL-switch TTL-open"><el-switch v-model="param.remind_free_limit_ad.is_open" @change="ChangeSetting('remind_free_limit_ad',param.remind_free_limit_ad.is_open)" /></div>
                <div class="TTL-value">
                    <wcinput
                        :value="param.remind_free_limit_ad.value"
                        :option="{placeholder:'请填写具体值',type:'input',clearable:true,ischange:true,isinput:true,width:'120px'}"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') param.remind_free_limit_ad.value=val.value;
                            if(val.type=='change') ChangeValue('remind_free_limit_ad',param.remind_free_limit_ad.value);
                        }"
                    />
                </div>
                <div class="TTL-value-note">（备注：{{param.remind_free_limit_ad.note}}）</div>
            </div>
            <div :class="param.disk_free_limit_add.isselect ? 'TTL-form-submit-content content-select' : 'TTL-form-submit-content' " ref="disk_free_limit_add">
                <span class="TTL-form-content-sub width150">新增店铺赠送图片空间</span>
                <div class="TTL-switch TTL-open"><el-switch v-model="param.disk_free_limit_add.is_open" @change="ChangeSetting('disk_free_limit_add',param.disk_free_limit_add.is_open)" /></div>
                <div class="TTL-value">
                    <wcinput
                        :value="param.disk_free_limit_add.value"
                        :option="{placeholder:'请填写具体值',type:'input',clearable:true,ischange:true,isinput:true,width:'120px'}"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') param.disk_free_limit_add.value=val.value;
                            if(val.type=='change') ChangeValue('disk_free_limit_add',param.disk_free_limit_add.value);
                        }"
                    />
                </div>
                <div class="TTL-value-note">（备注：{{param.disk_free_limit_add.note}}）</div>
            </div>
        </div>

    </div>
</div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_PLAT_SETTING from '@/Interface/Platsetting/Platsetting';
export default {
    components: {},
    data() {
        return {
           rollbackname:'',
           rollbackurl:'',
           param: {
               'member_free_limit_ad': {is_open:false,value:'',isselect:false},  //非付费添加会员数量是否限制
               'pet_free_limit_ad': {is_open:false,value:'',isselect:false},     //非付费添加宠物数量是否限制
               'record_free_limit_ad': {is_open:false,value:'',isselect:false},  //非付费添加记录数量是否限制
               'remind_free_limit_ad': {is_open:false,value:'',isselect:false},  //非付费添加日程提醒数量是否限制
               'disk_free_limit_add': {is_open:false,value:'',isselect:false},  //限制功能未续费时可上传文件的最大空间（单位：M）
               'xcx_push_login': {is_open:false,value:'',isselect:false},       //小程序发布开关，用于发布时显示官方登录审核入口，此处的值为设置指定店铺id为默认指定测试店铺
           },
        }
    },

    mounted() {
        this.OnloadMethod();
    },

    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetSettingDetails(); //获取小程序详细信息设置
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.GetSettingDetails();   //获取小程序详细信息设置
                this.GoToLabel(data.name);  //锚点定位
                //提取返回参数
                this.rollbackname=data.rollbackname;  
                this.rollbackurl=data.rollbackurl;
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GoToLabel(data.name);            //锚点定位
                //提取返回参数
                this.rollbackname=data.rollbackname;  
                this.rollbackurl=data.rollbackurl;
            }
        },
        

        /** 跳转到指定位置 **/
        GoToLabel(name) {
            this.$refs[name].scrollIntoView({behavior:'smooth',block:'center'});
            this.param[name].isselect=true;
            console.log(this.param[name]);
        },


        /** 取消选中的锚点 **/
        cannelSelect() {
            for(var key in this.param) 
            this.param[key].isselect=false;
        },


        /** 修改模块数据设置 **/
        ChangeSetting(label,value) {
            if(value==true) {value=1}else if(value==false) {value=0;}
            INTERFACE_PLAT_SETTING.UPDATE_SETTING({label:label,value:value}).then((res) => {
                if(res.status > 0) return false;
                this.GetSettingDetails();
            });
        },


        /** 修改模块数据值 **/
        ChangeValue(label,value) {
            INTERFACE_PLAT_SETTING.UPDATE_SETTING_VALUE({label:label,value:value}).then((res) => {
                if(res.status > 0) return false;
                this.GetSettingDetails();
            });
        },

        /////////////////////////////////////////
        /////////////////////////////////////////
        //基础操作
        
        /** 获取账号设置信息详情 **/
        GetSettingDetails() {
            var obj=document.getElementById("PlatShowSetting");
            this.$loading.openloading(obj);
            INTERFACE_PLAT_SETTING.GET_SETTING_DETAILS().then((res) => {
                if(res.status > 0) return false;
                var result=res.data;
                this.$loading.closeloading(obj);

                //调整值
                for(var key in result) {
                    result[key].is_open=result[key].is_open==1 ? true : false;
                    result[key].isselect=result[key].isselect==1 ? true : false;
                    this.param[key]=result[key];
                }
                
            });
        },


        /** 返回历史组件 **/
        GoBack() {
            var navinfo={name:this.rollbackname,labelentry:this.rollbackurl,components:this.rollbackurl,isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理

            //清空历史返回组件信息
            this.rollbackname='';
            this.rollbackurl='';
        },

        //基础操作
        /////////////////////////////////////////
        /////////////////////////////////////////

    },

}
</script>
<style lang="scss" Scoped>
.TTL-form-submit-title {font-size:13px;letter-spacing: 1px;padding:20px 0;border-bottom:1px solid #F2F6FC;display:inline-block;width:100%;position: relative;}
.TTL-form-submit-title i {position: absolute;width:10px;height:40%;background-color: #666eeb;top:30%;border-radius: 6px;}
.TTL-form-submit-title span {margin-left:20px;}
.TTL-form-submit-title h {font-size:12px;letter-spacing: 1px;color: crimson;margin-left:10px;zoom:.9;}
.TTL-form-submit-content {display: inline-flex;align-items: center;width:calc(100% - 100px);padding:20px 50px;font-size:13px;color:#666666;transition:.5s all;}
.content-select {
    background-image: url(@/assets/icon/jiantou.png);
    background-repeat: no-repeat;
    background-size: 18px;
    background-position: 20px center;
    background-color: #DCDFE6;
    border-radius: 6px;
}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-form-content-sub {margin-right:20px;font-size: 13px;line-height: 21px;letter-spacing: 1px;}
.TTL-open {width:auto;}
.TTL-value {margin-left:30px;}
.TTL-value-note {margin-left:30px;font-size:12px;color:crimson;letter-spacing: 1px;zoom:.9;}
</style>